import * as Types from './types';
import { DATE_PART, ISO_DATE_FORMAT } from './constants';

export const getDateFormatData = (dateFormat: string): Types.IDateFormatData => {
    const [firstPart, secondPart] = dateFormat.split(/[-/]/);

    return {
        year: {
            start: dateFormat.indexOf(DATE_PART.year), end: dateFormat.indexOf(DATE_PART.year) + DATE_PART.year.length
        },
        month: {
            start: dateFormat.indexOf(DATE_PART.month), end: dateFormat.indexOf(DATE_PART.month) + DATE_PART.month.length
        },
        day: {
            start: dateFormat.indexOf(DATE_PART.day), end: dateFormat.indexOf(DATE_PART.day) + DATE_PART.day.length
        },
        separator: {
            sign: dateFormat.charAt(firstPart.length),
            firstIndex: firstPart.length,
            secondIndex: firstPart.length + secondPart.length + 1
        }
    };
};

export const convertInputDate = ({ value, fromFormat, toFormat }: Types.IConvertInputDateParams): string => {
    if (!value) {
        return '';
    }

    if (value.length < toFormat.length) {
        return value;
    }

    const { year, month, day } = getDateFormatData(fromFormat);

    return toFormat
        .replace(DATE_PART.year, value.substring(year.start, year.end))
        .replace(DATE_PART.month, value.substring(month.start, month.end))
        .replace(DATE_PART.day, value.substring(day.start, day.end));
};

export const validateDateString = (dateStr: string): string => {
    try {
        const date = new Date(dateStr);
        const isInvalidDate = dateStr.length > ISO_DATE_FORMAT.length
            || !date.getTime()
            || !date.toISOString().includes(dateStr);

        return isInvalidDate ? '' : dateStr;
    } catch {
        return '';
    }
};
